import api from "@/api/viktor"

export async function patchUser(uuid, data) {
  const response = await api({
    method: "patch",
    url: `/user/${uuid}`,
    data,
  })

  return response
}
